import { ComponentPropsWithoutRef, forwardRef } from 'react';

import css from './styles.module.css';

type ConnectFieldsProps = ComponentPropsWithoutRef<'div'> & {
  children: React.ReactNode | React.ReactNode[];
};

export const ConnectedFields = forwardRef<HTMLDivElement, ConnectFieldsProps>(
  function ConnectedFields({ children, className, ...props }, ref) {
    const classes = [css.fields, className].filter(Boolean).join(' ');

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  }
);
